module.exports = __webpack_public_path__ + "static/img/train-station_256.4c28bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/train-station_256.png
// module id = 9/cy
// module chunks = 0